import type { ReactNode } from 'react';
import { css } from 'styled-system/css';
import { Container } from './Container';
import { Reveal } from './Reveal';
import { SectionHeader } from './SectionHeader';

export function splitEntryClass(): string {
  return css({
    borderTop: '1px solid',
    borderColor: 'border.hairline',
    _last: {
      borderBottom: '1px solid',
      borderBottomColor: 'border.hairline',
    },
  });
}

export function SplitSection({
  id,
  label,
  eyebrow,
  title,
  description,
  className,
  children,
}: {
  id?: string;
  label: string;
  eyebrow: string;
  title: string;
  description: string;
  className: string;
  children: ReactNode;
}) {
  return (
    <section id={id} aria-label={label} className={className}>
      <Container>
        <div
          className={css({
            display: 'grid',
            gridTemplateColumns: {
              base: '1fr',
              md: 'minmax(0, 2fr) minmax(0, 3fr)',
            },
            gap: { base: '10', md: '16' },
            alignItems: 'start',
          })}
        >
          <div
            className={css({ position: { md: 'sticky' }, top: { md: '28' } })}
          >
            <SectionHeader eyebrow={eyebrow} title={title} />
            <Reveal delay={100}>
              <p
                className={css({
                  fontSize: { base: 'sm', md: 'base' },
                  lineHeight: 'relaxed',
                  color: 'text.secondary',
                  maxWidth: '38ch',
                  marginTop: '5',
                })}
              >
                {description}
              </p>
            </Reveal>
          </div>
          <Reveal delay={160}>{children}</Reveal>
        </div>
      </Container>
    </section>
  );
}
